import { render } from "./TemplateManage.vue?vue&type=template&id=6211fec6&scoped=true"
import script from "./TemplateManage.vue?vue&type=script&lang=js"
export * from "./TemplateManage.vue?vue&type=script&lang=js"

import "./TemplateManage.vue?vue&type=style&index=0&id=6211fec6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6211fec6"

export default script